// 海外域名i.in.meizu.com
const INTERNATIONAL_HOSTNAME = 'i.in.meizu.com'

// 是否是海外环境
export const IS_INTERNATIONAL = location.hostname === INTERNATIONAL_HOSTNAME




// WEBPACK FOOTER //
// ./src/assets/const.js